import { MenuItem } from 'primeng/api';
const PAGES = '/pages';

export const PagesMenuSellerEssential: MenuItem[] = [
  {
    label: 'Punto de Venta',
    icon: 'pi pi-shopping-cart',
    items: [
      {
        label: 'Caja Registradora',
        icon: 'pi pi-money-bill',
        routerLink: [`${PAGES}/punto-de-venta/caja-registradora`]
      },
      {
        label: 'Ventas',
        icon: 'pi pi-arrow-up',
        routerLink: [`${PAGES}/punto-de-venta/ventas`]
      }
    ]
  },
  {
    label: 'Reportes',
    icon: 'pi pi-play',
    items: [
      {
        label: 'Ventas',
        icon: 'pi pi-play',
        routerLink: [`${PAGES}/reportes/ventas`]
      },
      {
        label: 'Caja Registradora',
        icon: 'pi pi-play',
        routerLink: [`${PAGES}/reportes/caja-registradora`]
      }
    ]
  }
];
